import * as types from '../types';



const initialState = {
  menu: {
    hindi: { data: [], lastFetched: null },
    english: { data: [], lastFetched: null }
  },
  loading: false,
  error: null,
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_MENU_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        menu: {
          ...state.menu,
          [action.language]: { data: action.payload, lastFetched: Date.now() }
        }
      };
    case types.FETCH_MENU_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.CLEAR_MENU:
      return { ...initialState };
    default:
      return state;
  }
};

export default menuReducer;
